module.exports = __webpack_public_path__ + "img/icon2.e5b42d99.png";